import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';




@Injectable()
export class EquipmentRecordActionService {


  constructor(private _http: HttpClient, ) { }

 

  private handleError(err: HttpErrorResponse): Observable<any> {
    // return Observable.throw(error.json().error || 'Server error');
    // return Observable.throw(error || 'Server error');
    console.log('handled error ' + err.status);
    return  Observable.throw(err || 'Server error');
  }
}
